import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, Checkbox } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { EditFilled, PlusCircleFilled } from "@ant-design/icons";
const { Text } = Typography;

const FinanceList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [financeList, setFinanceList] = useState([]);

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return localStorage.getItem("email") === "ec@57concrete.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "bpa@57concrete.com" ||
					localStorage.getItem("email") === "eliud@gmail.com" ? (
					<Button
						type="primary"
						icon={<EditFilled twoToneColor={"white"} />}
						onClick={(e) => history.push(`/finance/${record.id}`)}
					/>
				) : (
					""
				);
			},
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Email",
			dataIndex: "email",
			key: "email",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Phone",
			dataIndex: "phone",
			key: "phone",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Job Hold",
			dataIndex: "jobHold",
			key: "jobHold",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Active",
			dataIndex: "active",
			key: "active",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "QC User",
			dataIndex: "isQCUser",
			key: "isQCUser",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "File Permission",
			dataIndex: "filePermission",
			key: "filePermission",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
	];

	useEffect(() => {
		getFinanceList();
	}, []);

	const getFinanceList = async () => {
		setLoading(true);

		const url = api + "/user/list/57Concrete/Finance";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						name: item.name,
						email: item.email,
						jobHold: item.jobHold,
						phone: item.phone,
						active:
							item.active !== null && item.active !== undefined
								? item.active
								: true,
						isQCUser: item.isQCUser || false,
						filePermission: item.filePermission || false,
					});
				});
				setFinanceList(list);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewFinance = () => {
		history.push("/finance/new");
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				{(localStorage.getItem("email") === "ec@57concrete.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "bpa@57concrete.com" ||
					localStorage.getItem("email") === "eliud@gmail.com") && (
					<Button
						onClick={addNewFinance}
						type="primary"
						style={{
							width: 150,
						}}
						icon={<PlusCircleFilled />}
					>
						New Finance
					</Button>
				)}
				<CustomTable columns={columns} data={financeList} />
			</Flex>
		);
	};

	return (
		<Layout title="Finance" description="Finance List">
			<Flex vertical gap={"large"}>
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
		</Layout>
	);
};

export default FinanceList;
